/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_help_with_locked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` with your locked selections`)
};

const es_f1_apex_help_with_locked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` con tus selecciones bloqueadas`)
};

const de_f1_apex_help_with_locked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` mit deinen gesperrten Auswahlen`)
};

const nl_f1_apex_help_with_locked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` met je vergrendelde selecties`)
};

const fr_f1_apex_help_with_locked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` avec vos sélections verrouillées`)
};

const it_f1_apex_help_with_locked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` con le tue selezioni bloccate`)
};

const pt_br2_f1_apex_help_with_locked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` com suas seleções fixadas`)
};

const pt_f1_apex_help_with_locked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` com as suas seleções fixadas`)
};

const ja_f1_apex_help_with_locked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`（ロック済み選択含む）`)
};

const zh_f1_apex_help_with_locked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`（含锁定选择）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_help_with_locked = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_help_with_locked(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_help_with_locked", locale)
	if (locale === "en") return en_f1_apex_help_with_locked(inputs)
	if (locale === "es") return es_f1_apex_help_with_locked(inputs)
	if (locale === "de") return de_f1_apex_help_with_locked(inputs)
	if (locale === "nl") return nl_f1_apex_help_with_locked(inputs)
	if (locale === "fr") return fr_f1_apex_help_with_locked(inputs)
	if (locale === "it") return it_f1_apex_help_with_locked(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_help_with_locked(inputs)
	if (locale === "pt") return pt_f1_apex_help_with_locked(inputs)
	if (locale === "ja") return ja_f1_apex_help_with_locked(inputs)
	return zh_f1_apex_help_with_locked(inputs)
};